/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  console.log("CUSTOM JS WORKS")
  document.addEventListener('DOMContentLoaded', function () {
    const link = document.querySelector('.hero-banner__custom');

    if (link) {
      link.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        
        if (targetId && targetId.startsWith('#')) {
          e.preventDefault();
          const targetEl = document.querySelector(targetId);

          if (targetEl) {
            const yOffset = -60;
            const y = targetEl.getBoundingClientRect().top + window.scrollY + yOffset;

            window.scrollTo({
              top: y,
              behavior: 'smooth'
            });
          }
        }
      });
    }

    
    document.querySelectorAll('.flickity-enabled').forEach(slider => {
      let touchStartY = null;
      let touchStartX = null;

      slider.addEventListener('touchstart', function(e) {
        if (e.touches.length === 1) {
          touchStartY = e.touches[0].clientY;
          touchStartX = e.touches[0].clientX;
        }
      }, { passive: true });

      slider.addEventListener('touchmove', function(e) {
        if (e.touches.length === 1 && touchStartY !== null && touchStartX !== null) {
          const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
          const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
          // If the swipe is more vertical than horizontal, prevent Flickity drag
          if (deltaY > deltaX) {
            e.stopPropagation();
          }
        }
      }, { passive: false });
    });

  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
